import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminProductLandingEdit from "@/pages/admin/AdminProductLandingEdit";

export const Route = createFileRoute("/admin/product-landings/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminProductLandingEdit />
    </ProtectedRoute>
  ),
});
